import { BaseService } from 'hungry-core2'

import actions from '@actions'

export class CoreService extends BaseService {
  clearStore = () => {
    this.dispatch(actions.clearStore())
  }
}
